import { AxiosError } from 'axios';
import {
  BusStatus,
  DriverStatus,
  InvoiceStatus,
  RecipientType,
  RideLegSchemaType,
  UserPermission,
  UserRole,
} from 'remote/global';

export interface MobiferErrorResponse {
  error: string;
  errorCode: string;
  path: string;
  status: number;
  timestamp: number;
}

declare module '@tanstack/react-query' {
  interface Register {
    defaultError: AxiosError<MobiferErrorResponse>;
  }
}

export const STALE_FIVE_MINUTES = 1000 * 60 * 5; // 5 minutes
export const STALE_ONE_HOUR = 1000 * 60 * 60; // 60 minutes

export type PaginationQueryParams = {
  pageNo?: string;
  pageSize?: string;
  search?: string;
  sortBy?: string;
  sortDirection?: 'ASC' | 'DESC';
};

export interface PageDto<T> {
  elements: T;
  pageCount: number;
  pageNo: number;
  pageSize: number;
  totalElements: number;
}

export type ScheduleQueryParams = {
  start?: string;
  end?: string;
};

export type ExportCSVQueryParams = {
  start?: string;
  end?: string;
};

export type OperatorsListPaginationQueryParams = PaginationQueryParams & {
  approved?: string;
};

export type OperatorsInvoicesPaginationQueryParams = PaginationQueryParams & {
  bookingNumber?: string;
  identifier?: string;
  invoiceNumber?: string;
  status?: InvoiceStatus | '';
};

export type OperatorsVehiclesPaginationQueryParams = PaginationQueryParams & {
  licensePlate?: string;
  status?: BusStatus;
};

export type OperatorsDriversPaginationQueryParams = PaginationQueryParams & {
  name?: string;
  status?: DriverStatus;
};

export type OperatorsAlertsPaginationQueryParams = PaginationQueryParams & {
  history?: boolean;
};

export type OperatorsUserMessagingMessagesQueryParams = PaginationQueryParams & {
  groupId?: string;
  recipientType?: RecipientType;
  userId?: string;
};

export type OperatorsUserMessagingUsersQueryParams = PaginationQueryParams & {
  namePart?: string;
  excludeGroupId?: string;
};
export type OperatorsVehiclesLocationsQueryParams = PaginationQueryParams & {
  maxLat?: string;
  maxLon?: string;
  minLat?: string;
  minLon?: string;
};

export type AuthMutationResponse = {
  jwt: string;
  refreshToken: string;
};

export type UserAccessDto = {
  driverId?: number;
  email: string;
  operatorId: number;
  permissions: Record<string, UserPermission>;
  roles: UserRole[];
  userId: number;
};

export type CSVExportResult = {
  fileName: string;
  blob: Blob;
};

export type IDValueDtoLongString = {
  id: number;
  value: string;
};

export type VehicleActivationDto = {
  availableForOffer: boolean;
  vehicleIds: number[];
};

export type RideMoveRequest = {
  driverId?: string;
  rideId: string;
  vehicleId: string;
};

export type OfferPriceRequest = {
  newPriceExclVat: number;
  operatorOfferUuid: string;
  refNumber: string;
};

export type ItineraryRequest = {
  legs: RideLegSchemaType[];
  passengerCount: number;
  rejectFerryTrip: boolean;
};

export type ItineraryResponse = {
  adjusted: boolean;
  legs: RideLegSchemaType[];
  polylines: string[];
};
